import { RemoteGetCoordinatesFromAddress } from 'data/usecases/locations';
import { GetCoordinatesFromAddressUseCaseInterface } from 'domain/usecases';
import { makeApiUrlGetCoordinatesFromAddress } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetCoordinatesFromAddress =
  (): GetCoordinatesFromAddressUseCaseInterface =>
    new RemoteGetCoordinatesFromAddress(
      makeApiUrlGetCoordinatesFromAddress(),
      makeAxiosHttpClient(),
    );
